const LOGO_URL =
  "https://public.readdy.ai/ai/img_res/6f47fa6c-76ae-4bee-9f87-7e3f511aae95.png";

const NAV_ITEMS = ["Home", "About", "Products", "Features", "Contact"];

function scrollToSection(id: string) {
  const el = document.getElementById(id.toLowerCase());
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-gray-900 border-t border-white/10 py-12">
      <div className="max-w-screen-xl mx-auto px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Brand */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <img
                src={LOGO_URL}
                alt="ZAREV OOD"
                className="w-8 h-8 object-contain"
              />
            </div>
            <span className="text-white/70 font-semibold text-sm">
              ZAREV OOD
            </span>
          </div>

          {/* Nav links */}
          <nav className="flex flex-wrap items-center justify-center gap-6">
            {NAV_ITEMS.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="text-white/40 hover:text-white/70 text-xs uppercase tracking-widest font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                {item}
              </button>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-white/30 text-xs">
            &copy; {year} ZAREV OOD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
